import type { QueryEntity } from '@/sections/insights/queryBuilder/entities/types';

import { buildAssetColumns } from './columns';
import { getAssetFields } from './fields';
import { getAssetSimpleFilters } from './simpleFilters';

/**
 * Asset QueryEntity - bundles columns and fields
 */
export const assetEntity: QueryEntity<unknown> = {
  primaryLabel: { actual: 'Asset' },
  buildColumns:
    buildAssetColumns as () => import('@/components/table/types').Columns<unknown>,
  getFields: getAssetFields,
  getSimpleFilters: getAssetSimpleFilters,
};
